import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.482 17.902c-1.18.701-4.271 2.134-2.388 3.929.92.875 1.944 1.502 3.231 1.502h7.348c1.289 0 2.313-.626 3.232-1.502 1.883-1.794-1.208-3.228-2.388-3.93a8.88 8.88 0 0 0-9.035 0m8.268-7.486a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0"
    }, null, -1)
  ])))
}
export default { render: render }